export default {
  "1:1": "1:1",
  "4:3": "4:3",
  "16:9": "16:9",
};
